import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import { axiosRequestConfiguration } from './config';
import cookie from 'react-cookies';

const tokenFunction = () => {
    const token = sessionStorage.getItem('token_ethias');

    return `Bearer ${token}`;
};
const checkNumberFunction = () => {
    const checkNumber = sessionStorage.getItem('checkNumber');
    return checkNumber;
};

const initialization = (configs: AxiosRequestConfig): AxiosInstance => {
    const axiosInstance = axios.create(configs);

    axiosInstance.interceptors.request.use(async (request) => {
        if (request.url?.includes('url-decode')) {
            request.headers.SCH_ID = 'ETHIAS_2ND';
            return request;
        }

        if (!request.url?.includes('login') && !request.url?.includes('verification') && !request.url?.includes('url-decode')) {
            request.headers.Authorization = tokenFunction();
            request.headers.RequestId = checkNumberFunction();
            request.headers.SCH_ID = 'ETHIAS_2ND';
            return request;
        }
        return request;
    });
    return axiosInstance;
};

const axiosInstance = initialization(axiosRequestConfiguration);

export default axiosInstance;
